module.exports = __webpack_public_path__ + "img/pic1.e0a3a31d.jpg";